import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-responder',
  standalone: true,
  templateUrl: './help-responder.component.html',
  styleUrls: ['./help-responder.component.css'],
})
export class HelpResponderComponent {
  readonly parent = input.required<HelpComponent>();
}
